/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


$(document).ready(function()
{

    var reglas = {
        email:{ required: true, email:true},
        password: {required: true }
    };
    $(function(){
        $("#loginForm").validate({
            rules: reglas,
            ignore: ".ignore",
            resetForm:true,
            debug:true,
            submitHandler: function(form){
                $(form).ajaxSubmit(
                    {
                        beforeSubmit: function(){
                            $('.messageError').hide();
                            $('#submitbtn').attr('disabled', 'disabled').html("<i class='fa fa-circle-o-notch fa-spin'></i> loading...");
                        },
                        success: function(e)
                        {
                            var attempts = e['attempts'];
                            if(attempts == 0){
                                if(e['intended'].indexOf('login') !== -1 || e['intended'].indexOf('logout'))
                                    window.location.replace('/');
                                else
                                    window.location.replace(e['intended']);
                            }
                            else if(attempts <= 5){
                                $('#submitbtn').attr('disabled', false).html("Login");
                                if (attempts ==3)
                                    $('#recaptcha').show();
                                $('.messageError').html('The login information you provided is invalid. Please try again.');
                                $('.messageError').show();
                                if(attempts >= 3)
                                    grecaptcha.reset()
                            }
                            else {
                                $('#loginForm').hide();
                                $('.messageError').html('Your login attempt has failed. Click <a href="/login-failed" >Next</a> to continue.');
                                $('.messageError').show();
                            }

                        }
                    });
            },
            errorPlacement: function(error, element)
            {
                error.insertAfter(element.parent());
            }
        });
    });

});